import * as yup from 'yup';
import { validateOutboundTrackingNumber, validateTrackingnumberFromSap } from '../../helpers/formHelpers/formHelpers';
import ITInquery from '../../interfaces/inquiry/inquiry';

export const inquiryInitialValues: ITInquery = {
	sender: {
		trackingnumber: '',
		affiliate: '',
		address: '',
		zip: '',
		phone: '',
		email: '',
	},
	receiver: {
		name: '',
		nameContinue: '',
		address: '',
		addressContinue: '',
		city: '',
		zip: '',
		phone: '',
		email: '',
	},
	shipmentDetail: {
		packageDescription: '',
		contents: '',
		contentsValue: '',
	},
	comments: '',
};

export const inquirySchema = yup.object().shape({
	sender: yup.object().shape({
		trackingnumber: yup
			.string()
			.max(35, 'trackingnumberMax')
			.min(8, 'trackingnumberMin')
			.test('is-outbound-trackingnr', 'trackingnumberNotOutbound', validateOutboundTrackingNumber)
			.test('is-valid-trackingnr', 'trackingnumberNotFound', validateTrackingnumberFromSap)
			.required('required'),
		affiliate: yup.string().max(44, 'maxText').required('required'),
		address: yup.string().required('required'),
		zip: yup
			.string()
			.matches(/^[0-9]+$/, 'onlyNumbers')
			.required('required'),
		phone: yup
			.string()
			.max(14, 'maxNumbers')
			.matches(/^[0-9]+$/, 'onlyNumbers')
			.required('required'),
		email: yup.string().max(60, 'maxText').email('emailNotValid').required('required'),
	}),
	receiver: yup.object().shape({
		name: yup.string().max(44, 'maxText').required('required'),
		nameContinue: yup.string().max(35, 'maxText'),
		address: yup.string().max(35, 'maxText').required('required'),
		addressContinue: yup.string().max(35, 'maxText'),
		city: yup.string().max(35, 'maxText').required('required'),
		zip: yup.string().required('required'),
		phone: yup
			.string()
			.max(16, 'maxNumbers')
			.matches(/^[0-9]+$/, 'onlyNumbers')
			.required('required'),
		email: yup.string().max(60, 'maxText').email('emailNotValid').required('required'),
	}),
	shipmentDetail: yup.object().shape({
		packageDescription: yup.string().required('required'),
		contents: yup.string().required('required'),
		contentsValue: yup
			.string()
			.matches(/^[0-9]+$/, 'onlyNumbers')
			.required('required'),
	}),
	comments: yup.string().max(1000, 'tooLong'),
	// captchaValid: yup.boolean().test('is-valid-captcha', 'captcha-valid', value => value),
});
